// Update this file to change the "what i'm working on" section on the homepage.
// Each entry: { emoji, title, description, link (optional), linkText (optional) }

export const currentProjects = [
  {
    emoji: '🔨',
    title: 'Blue',
    description: 'building a company to change how people interact with AI day-to-day.',
    link: 'https://www.youtube.com/watch?v=V48lpQGIeb4',
    linkText: 'v1 demo →',
  },
  {
    emoji: '🧠',
    title: 'HCI Research Lab',
    description: 'real-time EEG classification pipeline (SVM, CNN, RNN) that detects emotional states from brainwave signals and feeds into an adaptive neurofeedback loop for mood regulation. union college.',
  },
  {
    emoji: '📱',
    title: 'Tariff',
    description: 'iOS app that charges you real money (~$10) for opening addictive apps. texts a friend when you break your commitment. applied to founders inc (canopy accelerator, SF).',
  },
  {
    emoji: '🏥',
    title: 'AI Voice Agent',
    description: 'multilingual voice agent for a cancer clinic in india. handles appointment booking in english, hindi, and bengali. built with deepgram, exotel, google calendar, and MSG91.',
  },
  {
    emoji: '📝',
    title: 'Senior Thesis',
    description: "exploring ZK proofs for verifiable AI model inference — how do you verify a model's output without revealing its weights? looking at work by modulus labs, EZKL, and giza.",
  },
  {
    emoji: '💰',
    title: 'Student Investment Fund',
    description: 'CIO managing risk and allocation for a $1M+ student-run fund at union college.',
  },
];
